export enum MedServicePackageType {
    Other,
    MedInspection
}